export default __webpack_public_path__ + "static/media/premium_female@2x.17f35165.png";